import { Box, SxProps, TextField, Theme, useTheme } from '@mui/material'
import React, { CSSProperties, InputHTMLAttributes } from 'react'

interface Props {
    placeholder: string
    inputValue: string
    setInputValue: (newUsername: string) => void
    defaultValue?: string
    styles?: CSSProperties
    typography?: SxProps<Theme>
    native?: InputHTMLAttributes<HTMLInputElement>
}

const LoginInputField = ({
    placeholder,
    inputValue,
    setInputValue,
    styles,
    typography,
    native,
}: Props) => {
    const theme = useTheme()
    const containerStyle = {
        border: '1px solid',
        borderRadius: theme.shape.borderRadius,
        paddingTop: '3px',
        paddingBottom: '3px',
        paddingLeft: '20px',
        width: '300px',
        marginBottom: '20px',
    }

    const textFieldStyle = {
        width: '100%',
        padding: '0 7px',
        input: {
            typography: 'text2',
            color: 'white',
            '&::placeholder': {
                color: theme.palette.custom.lightGray,
                opacity: 0.9,
            },
        },
    }

    const { type, autoComplete } = native || {}
    return (
        <Box sx={{ ...containerStyle, ...styles }}>
            <TextField
                type={type || 'text'}
                variant="standard"
                placeholder={placeholder}
                sx={{ ...textFieldStyle, ...typography }}
                value={inputValue || ''}
                // defaultValue={defaultValue || ''}
                onChange={(event) => {
                    setInputValue(event.target.value || '')
                }}
                autoComplete={autoComplete}
                InputProps={{
                    disableUnderline: true,
                    inputProps: {
                        ...native,
                        autoComplete,
                    },
                }}
            />
        </Box>
    )
}

export default LoginInputField
